import { render, staticRenderFns } from "./PagoPaycometComponent.vue?vue&type=template&id=2447a645"
import script from "./PagoPaycometComponent.vue?vue&type=script&lang=js"
export * from "./PagoPaycometComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports